import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import React from "react";
const PopBodProcessBlock = (props) => {
    const device = DeviceContext();
    return (React.createElement("div", { className: "popup-disclaimer-block" },
        React.createElement("div", { className: "d-flex align-items-center gap-12" },
            React.createElement("i", { className: "edel-icon-attention" }),
            React.createElement("div", { className: `txt-grey-shade1 ${device && (device === null || device === void 0 ? void 0 : device.isDesktop) ? " DMSanN_14_400 " : "DMsanR_10_400"}` }, props.bodProcessInfoMessage))));
};
export default PopBodProcessBlock;
